import { create } from "apisauce";
import { store } from "redux/store";

const apiService = create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
});

apiService.addAsyncRequestTransform((request) => async () => {
  const authToken = store.getState().auth.token;
  if (!authToken) return;
  request.headers["Authorization"] = "Bearer " + authToken;
});

export default apiService;
